/* tslint:disable */
/* eslint-disable */
export enum InvoiceRequestStatus {
  Success = 'SUCCESS',
  Failed = 'FAILED',
}
